module.exports = __webpack_public_path__ + "static/img/iotos.2cc2798.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/iotos.png
// module id = uYTY
// module chunks = 1